import filesEndpoint from 'app/api/services/filesEndpoint';
import _ from 'lodash';
import { hideLoading, showLoading } from "app/store/slices/settings";

export const handleChangeFile = (docParam, cdTipoDocumento, values) => {
  if (docParam.id) {
    const file = {
      idFile: docParam.id,
      fileName: docParam.name,
    };
    file.boExcluido = docParam.boExcluido || false;
    file.boAlterado = docParam.boAlterado || false;
    if (docParam.idGdoc) file.idGdoc = docParam.idGdoc;
    if (cdTipoDocumento) file.cdTipoDocumento = cdTipoDocumento;
    const documents = values?.documentos ? [...values.documentos] : [];
    let key = _.findIndex(documents, function(doc) {
      return doc.idFile === docParam.id;
    });
    if (key != null && key >= 0) {
      documents[key] = file;
    } else {
      key = _.findIndex(documents, function(doc) {
        return doc.cdTipoDocumento === cdTipoDocumento;
      });
      if (key != null && key >= 0) {
        documents[key] = file;
      } else {
        documents.push(file);
      }
    }
    if (values) {
      values.documentos = documents;
    }
  }
};

export const handleDeleteFile = (idFile, values, setFieldValue) => {
  if (values) {
    const documents = _.cloneDeep(values.documentos);
    const key = _.findIndex(documents, function(doc) {
      return doc.idFile === idFile;
    });
    if (documents[key]) {
      documents[key].boExcluido = true;
      if (documents[key].boAlterado !== null && documents[key].boAlterado !== undefined) {
        delete documents[key].boAlterado;
      }
    }
    values.documentos = documents;
  }
};

export const updateFile = async (idFile, oldFileName, newFileName, guest) => {
  if (idFile && oldFileName !== newFileName) {
    let response = null;
    try {
      const fileData = await filesEndpoint.getFileBlob(idFile);
      if (fileData?.status === 200 && fileData?.data) {
        const convertedFile = new Blob([fileData.data]);

        let tempFileName = oldFileName;
        const ext = tempFileName.split('.').pop();

        const sendingData = new FormData();
        sendingData.append('id', idFile);
        sendingData.append('filename', `${newFileName}.${ext}`);
        sendingData.append('file', convertedFile, `${newFileName}.${ext}`);

        if (guest) {
          response = await filesEndpoint.uploadGuestFile(sendingData);
        } else {
          response = await filesEndpoint.uploadFile(sendingData);
        }
      }
    } catch (e) {}
    return response;
  }
};

export const downloadFile = async (params) => {
  if (params.idFile) {
    if (params.dispatch) {
      params.dispatch(showLoading());
    }
    const file = await filesEndpoint.getFileBlob(params.idFile);
    if (file?.status === 200 && file?.data) {
      let contentType = file.headers["content-type"];
      let fileName = file.headers["file-name"];
      openFileByteArray({data: file.data, fileName: fileName, type: contentType});
    }
    if (params.dispatch) {
      params.dispatch(hideLoading());
    }
  }
};

export const openFileByteArray = ({data, fileName, type}) => {
  const file = new Blob([data], { type: type ? type : 'application/pdf' });
  const fileURL = URL.createObjectURL(file);

  const a = document.createElement("a");
  document.body.appendChild(a);
  a.id = "fake_link";
  a.style = "display: none";
  a.href = fileURL;
  a.download = fileName || "Relatório";
  a.click();
  const fakeLink = document.getElementById("fake_link");
  document.body.removeChild(fakeLink);
  window.URL.revokeObjectURL(fileURL);
};